import { createFileRoute } from "@tanstack/react-router";
import { OrgCreateContainer } from "@/features/organisation/containers/org-create-container";

export const Route = createFileRoute("/organisation/new")({
  component: OrgCreateContainer,
});
